import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {ClosedLeadConstantContactSubscriptionContainer} from '../card-containers/closed-lead-constant-contact-subscription-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function ClosedLeadConstantContactSubscriptions(props: Props) {
    return (
        <DragDropContext onDragEnd={() => {}}>
            <CollapsibleSection type='closedLeadConstantContactSubscriptions'>
                {['LEAD_WON', 'LEAD_LOST', 'LEAD_CANCELLED'].map((outcomeType) => (
                    <ClosedLeadConstantContactSubscriptionContainer
                        key={outcomeType}
                        // @ts-expect-error
                        outcomeType={outcomeType}
                        isLoading={props.isLoading}
                        errorMessage={props.errorMessage}
                        closedLeadAutomations={props.closedLeadAutomations}
                    />
                ))}
            </CollapsibleSection>
        </DragDropContext>
    );
}
